import React, { useContext } from 'react';

export const Context = React.createContext();

export const useBreadcrumbContext = () => useContext(Context);

const getCategory = (breadcrumbs) => {
  if (breadcrumbs && breadcrumbs[breadcrumbs.length - 1]) {
    return breadcrumbs[breadcrumbs.length - 1]?.displayName || '';
  }
  return '';
};

export const Provider = ({ breadcrumbs, children }) => {
  const contextValue = {
    breadcrumbs: breadcrumbs || [],
    category: getCategory(breadcrumbs),
  };

  return <Context.Provider value={contextValue}>{children}</Context.Provider>;
};
